import { render, staticRenderFns } from "./BudgetHeader.vue?vue&type=template&id=d2371bf6&scoped=true"
import script from "./BudgetHeader.vue?vue&type=script&lang=js"
export * from "./BudgetHeader.vue?vue&type=script&lang=js"
import style0 from "./BudgetHeader.vue?vue&type=style&index=0&id=d2371bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2371bf6",
  null
  
)

export default component.exports